var map = {
	"./bird 11.jpg": 66146,
	"./birds (2).jpg": 30732,
	"./boy 4.jpg": 35425,
	"./butter fly.jpg": 78046,
	"./fox 2.jpg": 33158,
	"./fox 3.jpg": 14211,
	"./fox 4.jpg": 83056,
	"./plan mt.jpg": 18711,
	"./rocket 2.jpg": 23069,
	"./rocket 3.jpg": 71936,
	"./uc browser 1.jpg": 74926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25297;